(function () {
  'use strict';

  // ---------- Pure calc (UNCHANGED — tested contract) ----------
  function compute(state) {
    var spb = (state.sqftPerBox > 0) ? state.sqftPerBox : 20;
    var priceCents = state.priceCents || 0;

    // Direct box mode: exact box count — no waste, no rounding up to an extra box
    if (state.mode === 'boxes') {
      var nb = Math.floor(parseFloat(state.boxes) || 0);
      var ppsBox = priceCents / 100;
      if (!(nb > 0)) {
        return {
          valid: false, desiredSqft: 0, effectiveSqft: 0, boxes: 0,
          totalSqft: 0, quantity: 0, subtotal: 0, was: null,
          pricePerSqft: ppsBox, sqftPerBox: spb, capped: false
        };
      }
      var tsBox = nb * spb;
      return {
        valid: true, desiredSqft: tsBox, effectiveSqft: tsBox, boxes: nb,
        totalSqft: tsBox, quantity: Math.round(tsBox), subtotal: tsBox * ppsBox,
        was: state.compareCents ? tsBox * (state.compareCents / 100) : null,
        pricePerSqft: ppsBox, sqftPerBox: spb, capped: false
      };
    }

    var desiredSqft = 0;

    if (state.mode === 'room') {
      var rooms = state.rooms || [];
      for (var i = 0; i < rooms.length; i++) {
        var w = parseFloat(rooms[i].w) || 0;
        var l = parseFloat(rooms[i].l) || 0;
        if (w > 0 && l > 0) desiredSqft += w * l;
      }
    } else {
      desiredSqft = parseFloat(state.sqft) || 0;
    }

    var MAX = 100000, capped = false;
    if (desiredSqft > MAX) { desiredSqft = MAX; capped = true; }

    if (!(desiredSqft > 0)) {
      return {
        valid: false, desiredSqft: 0, effectiveSqft: 0, boxes: 0,
        totalSqft: 0, quantity: 0, subtotal: 0, was: null,
        pricePerSqft: priceCents / 100, sqftPerBox: spb, capped: false
      };
    }

    var effectiveSqft = state.waste ? desiredSqft * 1.10 : desiredSqft;
    var boxes = Math.ceil(effectiveSqft / spb);
    var totalSqft = boxes * spb;
    var quantity = Math.round(totalSqft);
    var pricePerSqft = priceCents / 100;
    var subtotal = totalSqft * pricePerSqft;
    var was = state.compareCents ? totalSqft * (state.compareCents / 100) : null;

    return {
      valid: true, desiredSqft: desiredSqft, effectiveSqft: effectiveSqft,
      boxes: boxes, totalSqft: totalSqft, quantity: quantity,
      subtotal: subtotal, was: was, pricePerSqft: pricePerSqft,
      sqftPerBox: spb, capped: capped
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { compute: compute };
  }
  if (typeof document === 'undefined') return;

  // ---------- Browser ----------
  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function round2(n) { return Math.round(n * 100) / 100; }

  function initCalc(root) {
    if (root.__z4init) return;
    root.__z4init = true;

    var state = {
      mode: 'boxes',
      boxes: 1,
      sqft: '',
      rooms: [{ w: '', l: '' }],
      waste: true,
      sqftPerBox: parseFloat(root.getAttribute('data-sqft-per-box')) || 20,
      priceCents: parseFloat(root.getAttribute('data-price-cents')) || 0,
      compareCents: parseFloat(root.getAttribute('data-compare-cents')) || 0
    };

    var qs = function (s) { return root.querySelector(s); };
    var qsa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    // hidden cart inputs (contract — unchanged names)
    var qtyEl = qs('[data-z4-qty]');
    var totalEl = qs('[data-z4-totalsqft]');
    var boxesHiddenEl = qs('[data-z4-boxes]');

    var modeBtns = qsa('[data-z4-mode]');
    var panels = {
      boxes: qs('[data-z4-panel="boxes"]'),
      sqft: qs('[data-z4-panel="sqft"]'),
      room: qs('[data-z4-panel="room"]')
    };
    var boxQtyEl = qs('[data-z4-boxqty]');
    var sqftIn = qs('[data-z4-sqft]');
    var roomsWrap = qs('[data-z4-rooms]');
    var roomTotalEl = qs('[data-z4-roomtotal]');
    var roomTpl = qs('[data-z4-room-template]');
    var wasteRow = qs('[data-z4-wasterow]');
    var wasteIn = qs('[data-z4-waste]');

    var rBoxes = qs('[data-z4-r-boxes]');
    var rSqft = qs('[data-z4-r-sqft]');
    var rTotal = qs('[data-z4-r-total]');
    var ctaTotal = qs('[data-z4-cta-total]');
    var cta = qs('.z4c__cta');
    var affirmEl = qs('[data-z4-affirm]');

    // ---- build a compute() state from current UI ----
    function currentState() {
      if (state.mode === 'boxes') {
        return { mode: 'boxes', boxes: state.boxes, sqftPerBox: state.sqftPerBox, priceCents: state.priceCents, compareCents: state.compareCents };
      }
      if (state.mode === 'sqft') {
        return { mode: 'sqft', sqft: state.sqft, waste: state.waste, sqftPerBox: state.sqftPerBox, priceCents: state.priceCents, compareCents: state.compareCents };
      }
      return { mode: 'room', rooms: state.rooms, waste: state.waste, sqftPerBox: state.sqftPerBox, priceCents: state.priceCents, compareCents: state.compareCents };
    }

    function syncCart(r) {
      if (qtyEl) qtyEl.value = r.valid ? r.quantity : 0;
      if (totalEl) totalEl.value = r.valid ? r.totalSqft.toFixed(2) : '0';
      if (boxesHiddenEl) boxesHiddenEl.value = r.valid ? r.boxes : 0;
    }

    // ---- live Affirm refresh (debounced) ----
    var affirmTimer = null;
    function refreshAffirm(subtotal) {
      if (!affirmEl) return;
      affirmEl.setAttribute('data-amount', String(Math.round(subtotal * 100)));
      clearTimeout(affirmTimer);
      affirmTimer = setTimeout(function () {
        if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
          try { window.affirm.ui.refresh(); } catch (e) {}
        }
      }, 300);
    }

    function render() {
      var r = compute(currentState());
      syncCart(r);

      if (rBoxes) rBoxes.textContent = r.valid ? r.boxes : 0;
      if (rSqft) rSqft.textContent = r.valid ? round2(r.totalSqft) : 0;
      if (rTotal) rTotal.textContent = money(r.valid ? r.subtotal : 0);
      if (ctaTotal) ctaTotal.textContent = money(r.valid ? r.subtotal : 0);
      if (cta) cta.disabled = !r.valid;

      refreshAffirm(r.valid ? r.subtotal : (state.priceCents / 100));

      // keep boxes stepper coherent when computed from area
      if (state.mode !== 'boxes' && r.valid) {
        state.boxes = r.boxes;
        if (boxQtyEl) boxQtyEl.value = r.boxes;
      }
    }

    // ---- mode switching ----
    function setMode(mode) {
      state.mode = mode;
      modeBtns.forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-z4-mode') === mode ? 'true' : 'false');
      });
      Object.keys(panels).forEach(function (k) {
        var p = panels[k]; if (!p) return;
        var on = (k === mode);
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      if (wasteRow) {
        if (mode === 'boxes') { wasteRow.setAttribute('hidden', ''); }
        else { wasteRow.removeAttribute('hidden'); }
      }
      render();
      if (mode === 'sqft' && sqftIn) { sqftIn.focus(); }
      else if (mode === 'room' && roomsWrap) { var fi = roomsWrap.querySelector('[data-z4-w]'); if (fi) fi.focus(); }
    }
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-z4-mode')); });
    });

    // ---- boxes stepper ----
    function setBoxes(n) {
      n = Math.max(1, Math.floor(n) || 1);
      state.boxes = n;
      if (boxQtyEl) boxQtyEl.value = n;
      render();
    }
    var boxMinus = qs('[data-z4-boxminus]');
    var boxPlus = qs('[data-z4-boxplus]');
    if (boxMinus) boxMinus.addEventListener('click', function () { setBoxes(state.boxes - 1); });
    if (boxPlus) boxPlus.addEventListener('click', function () { setBoxes(state.boxes + 1); });
    if (boxQtyEl) {
      boxQtyEl.addEventListener('input', function () {
        var v = parseInt(boxQtyEl.value, 10);
        state.boxes = (isNaN(v) || v < 1) ? 1 : v;
        render();
      });
      boxQtyEl.addEventListener('blur', function () { setBoxes(state.boxes); });
    }

    // ---- sqft ----
    if (sqftIn) sqftIn.addEventListener('input', function () { state.sqft = sqftIn.value; render(); });

    // ---- waste ----
    if (wasteIn) wasteIn.addEventListener('change', function () { state.waste = wasteIn.checked; render(); });

    // ---- rooms ----
    function updateRoomTotal() {
      var r = compute({ mode: 'room', rooms: state.rooms, waste: false, sqftPerBox: state.sqftPerBox, priceCents: 0, compareCents: 0 });
      if (roomTotalEl) roomTotalEl.innerHTML = 'Total area: <strong>' + round2(r.desiredSqft) + ' sq ft</strong>';
    }
    function renderRooms() {
      if (!roomsWrap || !roomTpl) return;
      roomsWrap.innerHTML = '';
      state.rooms.forEach(function (room, idx) {
        var node = roomTpl.content.firstElementChild.cloneNode(true);
        var n = node.querySelector('[data-z4-roomn]'); if (n) n.textContent = (idx + 1);
        var wEl = node.querySelector('[data-z4-w]');
        var lEl = node.querySelector('[data-z4-l]');
        wEl.value = room.w; lEl.value = room.l;
        wEl.addEventListener('input', function () { state.rooms[idx].w = wEl.value; updateRoomTotal(); render(); });
        lEl.addEventListener('input', function () { state.rooms[idx].l = lEl.value; updateRoomTotal(); render(); });
        var del = node.querySelector('[data-z4-roomdel]');
        del.style.display = state.rooms.length > 1 ? '' : 'none';
        del.addEventListener('click', function () { state.rooms.splice(idx, 1); renderRooms(); updateRoomTotal(); render(); });
        roomsWrap.appendChild(node);
      });
    }
    var addRoomBtn = qs('[data-z4-addroom]');
    if (addRoomBtn) addRoomBtn.addEventListener('click', function () { state.rooms.push({ w: '', l: '' }); renderRooms(); updateRoomTotal(); render(); });

    // ---- init ----
    renderRooms();
    updateRoomTotal();
    setMode('boxes');
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('flooring-calculator'), initCalc);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
